import React from "react";
import ComplaintBot from "../components/dashboard/ComplaintBot";
import waterDropLogo from "../assets/images/logo.png";
import bgImage from "../assets/images/bg.png";
import sidebarImage from "../assets/images/Rectangle 5191.png";
import dashboardIcon2 from "../assets/images/grid-view2.png";
import { useNavigate } from "react-router-dom";
import Feedback from "../components/feedback";
import Translation from "../components/commonComponent/Language/language";
import { useAuth } from "../utils/AuthContext";
import { useState } from "react";

// main component of app
// default ui component for home page
function BotDesk() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [lang, setLang] = useState(() => sessionStorage.getItem("appLang") || "en");

  const changeLang = (newLang) => {
    setLang(newLang);
    sessionStorage.setItem("appLang", newLang);
  };

  const t = Translation[lang]?.ui || Translation.en.ui;

  const handleSignOut = () => {
    ["email", "name", "userId"].forEach((key) => sessionStorage.removeItem(key));
    logout();
    navigate("/");
  };

  const handleBackClick = () => {
    navigate("/desk");
  };
  const handleNewChat = () => {
    navigate(0);
  };

  return (
    <div className="flex-1 flex flex-col overflow-hidden">

      {/* Mobile Top Navigation */}
      <div className="flex sm:hidden w-full bg-page-bg border-b border-cream px-4 py-2 gap-3 justify-between overflow-x-auto shrink-0">
        <button
          onClick={handleBackClick}
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap bg-brand-teal text-white"
        >
          <img src={dashboardIcon2} alt="" className="w-4 h-4" />
          {t.dashboard || "Dashboard"}
        </button>
        <button
          className="flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs font-semibold shrink-0 whitespace-nowrap bg-white text-black border border-cream"
          onClick={handleNewChat}
        >
          <img alt="logo" src={waterDropLogo} className="w-4 h-4 shrink-0" />
          {t.lodgeComplaint || "Lodge Complaint"}
        </button>
      </div>

      {/* Desktop row: sidebar + content */}
      <div className="flex-1 flex overflow-hidden bg-page-bg">
        <div className="hidden sm:flex flex-col w-[250px] min-w-[250px] bg-gradient-to-b from-white to-[#fbeef1] border-r border-[#e8d3d8] shadow-[2px_0_16px_rgba(74,14,30,0.05)] pt-5 px-4 pb-4 shrink-0 justify-between h-full overflow-y-auto relative z-[5]">
          <div className="flex flex-col gap-[10px] w-full">
            <button
              onClick={handleBackClick}
              className="w-full flex items-center gap-[10px] py-[13px] px-[16px] rounded-[8px] font-[700] text-[14px] text-[#4a0e1e] border-[1.5px] border-[#e8d3d8] transition-colors duration-150 hover:border-[#0e8f6f]"
            >
              <i className="fa-solid fa-table-columns w-[16px] text-center"></i>
              {t.dashboard || "Dashboard"}
            </button>

            <button
              className="w-full flex items-center gap-[10px] py-[13px] px-[16px] rounded-[8px] font-[700] text-[14px] text-white bg-gradient-to-r from-[#4a0e1e] to-[#9c2942] shadow-[0_4px_14px_rgba(156,41,66,0.3)] border-transparent transition-colors duration-150"
              onClick={handleNewChat}
            >
              <i className="fa-solid fa-comment-medical w-[16px] text-center"></i>
              {t.lodgeComplaint || "Lodge Complaint"}
            </button>
          </div>

          <div className="flex-1"></div>

          <div className="flex flex-col gap-[10px]">
            <Feedback lang={lang} />
            <button onClick={handleSignOut} className="w-full flex items-center justify-center gap-[10px] py-[13px] px-[16px] rounded-[8px] font-[700] text-[14px] text-[#9c2942] bg-[#f7eef0] border-[1.5px] border-[#9c2942] hover:bg-[#9c2942] hover:text-white shadow-sm transition-all duration-200 cursor-pointer">
              <i className="fa-solid fa-arrow-right-from-bracket w-[16px] text-center"></i>
              {t.logout || "Logout"}
            </button>
          </div>
        </div>
        <ComplaintBot lang={lang} setLang={changeLang} />
      </div>
    </div>
  );
}

export default BotDesk;
